import React, { Component } from 'react';
import { Link, DirectLink, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import { Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';

class MainNavbar extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  componentDidMount() {
    Events.scrollEvent.register('begin', function () {
      console.log("begin", arguments);
    });

    Events.scrollEvent.register('end', function () {
      console.log("end", arguments);
    });
  }

  componentWillUnmount() {
    Events.scrollEvent.remove('begin');
    Events.scrollEvent.remove('end');
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <div className="MainNavbar">
        <Navbar color="light" light expand="md" className="fixed-top">
          <NavbarBrand className="ml-4 ml-md-0 newFont">Alessio Mantelli</NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="mx-auto" navbar>
              <NavItem>
                <Link activeClass="active" to="home-section" spy={true} smooth={true} duration={500}>
                  <NavLink href="">Home</NavLink>
                </Link>
              </NavItem>
              <NavItem>
                <Link activeClass="active" to="editor-section" spy={true} smooth={true} duration={500} offset={-50}>
                  <NavLink className="margin-right" href="">Chi sono</NavLink>
                </Link>
              </NavItem>
              <NavItem>
                <Link activeClass="active" to="servizi-section" spy={true} smooth={true} duration={500} offset={-50}>
                  <NavLink className="margin-left" href="">Servizi</NavLink>
                </Link>
              </NavItem>
              <NavItem>
                <Link activeClass="active" to="contatti-section" spy={true} smooth={true} duration={500}>
                  <NavLink href="">Contatti</NavLink>
                </Link>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

export default MainNavbar;



// WEBPACK FOOTER //
// ./src/components/MainNavbar.js